export default "/static/build/about-us-hero.webp";